import Navbar from './components/Navbar';
import Sections from './components/Sections';

function App() {
    return (
        <div className="text-white">
            <Navbar />
            <Sections />
        </div>
    );
}

export default App;
